<ng-container *ngIf="permConfig.isAddAllowed">
<form [formGroup]="addZoneForm" (ngSubmit)="onSaveClick()" (keydown.enter)="onSaveClick()">
<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Add Zone</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')" (keydown.enter)="$event.preventDefault()"></button>
</div>
<div class="modal-body">
        <div class="row">
            <div class="col-6">
                <div class="mb-2">
                    <label for="zodeCode" class="form-label">Code</label>
                    <input id="zodeCode" type="text" class="form-control form-control-sm" formControlName="txtZoneCode" placeholder="For e.g. ZE"
                        [ngClass]="{'is-invalid': (isFormSubmitted || addZoneForm.get('txtZoneCode')?.dirty) && addZoneForm.get('txtZoneCode').errors}">
                    <div *ngIf="(isFormSubmitted || addZoneForm.get('txtZoneCode')?.dirty) && addZoneForm.get('txtZoneCode').errors"
                        class="invalid-feedback">
                        <span *ngIf="addZoneForm.get('txtZoneCode').errors.required">Zone code
                            is required.</span>
                    </div>
                </div>
            </div>
            <div class="col-6">
                <div class="mb-2">
                    <label for="zoneTitle" class="form-label">Title</label>
                    <input id="zoneTitle" type="text" class="form-control form-control-sm" formControlName="txtZoneTitle" placeholder="For e.g. EAST"
                        [ngClass]="{'is-invalid': (isFormSubmitted || addZoneForm.get('txtZoneTitle')?.touched) && addZoneForm.get('txtZoneTitle').errors}">
                    <div *ngIf="(isFormSubmitted || addZoneForm.get('txtZoneTitle')?.touched) && addZoneForm.get('txtZoneTitle').errors"
                        class="invalid-feedback">
                        <span *ngIf="addZoneForm.get('txtZoneTitle').errors.required">Zone title
                            is required.</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <div class="modal-footer">
        <button type="submit" class="btn btn-outline-dark">Save</button>
    </div>
</form>
</ng-container>
<ng-container *ngIf="!permConfig.isAddAllowed">
  <app-forbidden></app-forbidden>
</ng-container>